module.exports = __webpack_public_path__ + "static/media/givingPrize3.b313860a.jpeg";